import axios from "axios";

// Set default axios configuration
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// Add a request interceptor to handle authentication errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Don't redirect if we're already on login page or checking auth status
      const isAuthCheck = error.config.url?.includes("/auth/user");
      const isOnLoginPage = window.location.pathname.includes("/login");
      // Don't redirect on shared/solo pages (shopping list or wish list shared links)
      const isSoloPage =
        /^\/shopping-list\/[^/]+$/.test(window.location.pathname) ||
        window.location.pathname.startsWith("/wish-list/shared/");

      // Only redirect to login if unauthorized and not already on login page or solo page
      if (!isOnLoginPage && !isAuthCheck && !isSoloPage) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
